import {Box, css, styled} from '@mui/material';
import type {StyledProps} from './types';

const StyledBox = styled(Box)<StyledProps>`
	width: 100%;
	${({theme}) => theme.breakpoints.up('lg')} {
		padding: 4px;
	}

	${({theme}) => theme.breakpoints.between('lg', 'xl')} {
		padding: 0;

		& .slide {
			flex: 0 0 88%;
		}
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		& .slide {
			flex-basis: 90%;
		}

		& .slide:first-of-type {
			flex-basis: 95%;
		}

		& .slide:last-of-type {
			flex-basis: 95%;
		}
	}

	${({$isSingleItem}) =>
		$isSingleItem &&
		css`
			${({theme}) => theme.breakpoints.down('sm')} {
				& .slide {
					flex-basis: 100%;
				}

				& .slide:first-of-type {
					flex-basis: 100%;
				}

				& .slide:last-of-type {
					flex-basis: 100%;
				}
			}
		`}
`;

const StyledDotButton = styled('div')`
	background-color: ${({theme}) => theme.palette.action.hover};
	width: 8px;
	height: 8px;
	border-radius: 50%;
`;

const DotsContainer = styled('div')`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	margin-top: 8px;
	padding-inline: 24px;
`;

export {StyledBox, StyledDotButton, DotsContainer};
